// This is the entry point for the home component
import React, { FC, useCallback, useContext } from 'react';

// Redux
import { Dispatch } from 'redux';

// Styling
import injectSheet from 'react-jss';
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import { FilterSlider } from 'Components/FilterSlider';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import withErrorBoundary from 'HOC/ErrorBoundary';
import styleSheet from './styles';

// Actions
import { setGPAValue } from '../actions/prospectProfile.actions';

// Classes
import { Range } from '../../classes/filter.classes';

// Components

interface Props {
  gpa: any;
  dispatch: Dispatch<any>;
  classes: any;
}

const GPAContainer: FC<Props> = (props: Props) => {
  const { gpa, dispatch, classes } = props;

  const {
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);
  const gpaCallback = (event: any) => {
    const { id, value } = event.target;
    const valueLowerCase = value.toLocaleLowerCase();

    // Combined Analytics Event
    // This tracks the user selecting any in the filters.  It also deals with the changing types of value
    if (typeof value === 'string' && valueLowerCase === 'any') {
      filterTrack({
        filterCategory: 'Prospect Profile',
        filterName: `GPA - Any`,
        filterValue: 'Any',
        addToStore: true,
      });
    } else if (
      typeof value === 'string' &&
      valueLowerCase === 'specific gpa range'
    ) {
      filterTrack({
        filterCategory: 'Prospect Profile',
        filterName: `GPA - Specific Gpa Range`,
        filterValue: '0.0 - 4.0',
        addToStore: true,
      });
    }

    setGPAValue(dispatch, gpa, value, id);
  };

  const gpaRangeSliderChange = (values: number[]) => {
    const value = new Range(values[0], values[1]);
    // Combined Analytics Event
    filterTrack({
      filterCategory: 'Prospect Profile',
      filterName: `GPA`,
      filterValue: `${values[0]} - ${values[1]}`,
      addToStore: true,
    });
    setGPAValue(dispatch, gpa, value, 'value');
  };

  return (
    <div className={classes.container}>
      <FilterRadioHidden
        label="Any"
        value="Any"
        selected={gpa.selection === 'Any'}
        identifier="selectionProspectProfileGPA"
        onClick={useCallback(gpaCallback, [gpa])}
      />
      <FilterRadioHidden
        label="Specific GPA Range"
        value="Specific GPA Range"
        selected={gpa.selection === 'Specific GPA Range'}
        identifier="selectionProspectProfileGPA"
        onClick={useCallback(gpaCallback, [gpa])}
        overrideStyles={{
          marginLeft: '27px',
        }}
      >
        <FilterSlider
          defaultValues={{
            handleOne: gpa.value.lower,
            handleTwo: gpa.value.upper,
          }}
          range={{ lowerBound: 0.0, upperBound: 4.0 }}
          step={0.1}
          onSlideEnd={useCallback(gpaRangeSliderChange, [gpa])}
          valuePlacesPastTheDecimal={1}
          ariaLabel="Select Year Range"
        />
      </FilterRadioHidden>
    </div>
  );
};

export default withErrorBoundary(injectSheet(styleSheet)(GPAContainer));
